import React from "react";
import { IconButton } from "@outpave/ds";

interface SectionGlyphProps {
  /** Required label for assistive tech, since the mark carries meaning. */
  "aria-label": string;
  /** Container tint. Defaults to the icon button's own neutral soft fill. */
  background?: string;
  children: React.ReactNode;
}

/**
 * The glyph a panel section heading carries: the DS icon button's shape
 * without its semantics.
 *
 * A `span`, not a `button`, because there is nothing to click. Rendered as a
 * real button it lands in the tab order and announces itself as a control
 * that does nothing. Pointer events are off for the same reason: the soft
 * variant's hover tint would advertise an interaction that does not exist.
 */
const SectionGlyph: React.FC<SectionGlyphProps> = ({
  "aria-label": label,
  background,
  children,
}) => (
  <IconButton
    component="span"
    aria-label={label}
    color="default"
    variant="soft"
    size="small"
    sx={{
      cursor: "default",
      pointerEvents: "none",
      ...(background ? { backgroundColor: background } : {}),
    }}
  >
    {children}
  </IconButton>
);

export default SectionGlyph;
